"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OverlapRemovalRefiner = /*#__PURE__*/function () {
  function OverlapRemovalRefiner() {
    _classCallCheck(this, OverlapRemovalRefiner);
  }

  _createClass(OverlapRemovalRefiner, [{
    key: "refine",
    value: function refine(context, results) {
      if (results.length < 2) {
        return results;
      }

      var filteredResults = [];
      var prevResult = results[0];

      for (var i = 1; i < results.length; i++) {
        var result = results[i];

        if (result.index < prevResult.index + prevResult.text.length) {
          if (result.text.length > prevResult.text.length) {
            prevResult = result;
          }
        } else {
          filteredResults.push(prevResult);
          prevResult = result;
        }
      }

      if (prevResult != null) {
        filteredResults.push(prevResult);
      }

      return filteredResults;
    }
  }]);

  return OverlapRemovalRefiner;
}();

exports.default = OverlapRemovalRefiner;